export default [
  {
    path: "/",
    redirect: "/login-checker"
  },
  {
    path: "/spreadsheet",
    name: "spreadsheet",
    component: () => import("@/views/Spreadsheet.vue"),
    meta: { rule: "editor" }
  },
  {
    path: "/dashboards/:dashboardHash?",
    name: "dashboard",
    component: () => import("@/views/DashboardAnalytics.vue"),
    meta: { rule: "editor" }
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/Home.vue"),
    meta: {
      rule: "editor",
      breadcrumb: [{ title: "Home", active: true }],
      pageTitle: "Home"
    }
  },
  {
    path: "/dashboard/layout",
    name: "dashboard-layout",
    component: () => import("@/views/DashboardLayout.vue"),
    meta: { rule: "editor" }
  },
  {
    path: "/dashboard/layout-two",
    name: "dashboard-layout-two",
    component: () => import("@/views/DashboardAnalyticsTwo.vue"),
    meta: { rule: "editor" }
  },
  {
    path: "/dashboard/ecommerce",
    name: "dashboard-ecommerce",
    component: () => import("@/views/DashboardECommerce.vue"),
    meta: { rule: "admin" }
  }
];

